const getStatesUrl = '/common/states/';

export default getStatesUrl;
